import {useCatalog} from "../../store/catalog";

export function SearchBox() {
    const {stagedSearch, stageSearch} = useCatalog()

    const handleChange = (e) => {
        stageSearch(e.target.value);
    };

    const clearSearch = () => stageSearch('');

    return (
        <div className="relative w-full">
            <div className="absolute left-0 top-1/2 -translate-y-1/2 text-primary pointer-events-none">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                </svg>
            </div>
            <input
                type="text"
                placeholder="Search products..."
                className="input input-ghost w-full pl-8 pr-8 bg-transparent focus:bg-transparent border-b border-base-200 rounded-none focus:border-primary transition-all px-0"
                value={stagedSearch || ''}
                onChange={handleChange}
            />
            {stagedSearch && (
                <button
                    type="button"
                    className="absolute right-0 top-1/2 -translate-y-1/2 text-gray-400 hover:text-primary w-6 h-6 flex items-center justify-center transition-colors"
                    onClick={clearSearch}
                    aria-label="Clear search"
                >
                    <span className="text-lg">✕</span>
                </button>
            )}
        </div>
    );
}